// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LedgerPaymentAccount from './data'

export default function LedgerPaymentAccountFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LedgerPaymentAccount">
      <LedgerPaymentAccount {...props}>
        {children}
      </LedgerPaymentAccount>
    </Flow>
  )
}
